module.exports = __webpack_public_path__ + "img/traffic-light-dark.b904ef3b.svg";